/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";
import { Outlet } from "react-router-dom";
import { useGlobal } from '../../../context/GlobalContextProvider';
import { usePreview } from "../../../context/PreviewContextProvider.js";
//Commons components
import Header from "./Template/Header.jsx";
import Footer from "./Template/Footer.jsx";
import Spinner from "../../Common/Spinner.jsx";

function PreviewLayout() {
  const { data } = usePreview();
  const { campaign, artPack, spinner } = useGlobal();

  const showHF = useMemo(() => {
    const previewSource = sessionStorage.getItem('previewSource');
    const previewContext = sessionStorage.getItem('previewContext');

    // Three preview modes:
    // 1. Sponsor + navbar preview: show header/footer and full site
    // 2. Sponsor + campaign form preview: hide header/footer, show only mint page
    // 3. Artist + navbar preview: hide header/footer, show only mint page

    if (previewSource === 'sponsor' && previewContext === 'navbar') {
      // Sponsor navbar preview - show header/footer
      return true;
    } else {
      // Sponsor campaign form preview OR Artist navbar preview - hide header/footer
      return false;
    }
  }, [campaign, artPack]);
  return (
    <div>
      {showHF && <Header data={data} />}
      <div className="d-flex" id="wrapper">
        <div id="page-content-wrapper">
          {/* Content */}
          <div className="container-fluid">
            <Spinner spinner={spinner} />
            <Outlet />
          </div>
          {showHF && <Footer data={data} />}
        </div>
      </div>
    </div>
  );
}

export default PreviewLayout;
